export default __webpack_public_path__ + "static/media/datadog.9f58c005.svg";